import {
  entityPatientOutpatientSurgery, entityPatient, entityMaterialLot, entityPatientRecommendedVisit, entityPurchaseOrder,
  entityPatientPayment, entitySchedulerPatient, entityTreatmentDiary
} from '@/libs/acl/entities'

export default [
  {
    path: '/reports/form-039',
    name: 'report-form-039',
    component: () => import('@/views/reports/ReportForm039'),
    meta: {
      resource: entityPatient,
      action: 'read',
      title: 'ReportForm039'
    }
  },
  {
    path: '/reports/form-039-3',
    name: 'report-form-039-3',
    component: () => import('@/views/reports/ReportForm039_3'),
    meta: {
      resource: entityPatient,
      action: 'read',
      title: 'ReportForm039_3'
    }
  },
  {
    path: '/reports/form-037',
    name: 'report-form-037',
    component: () => import('@/views/reports/ReportForm037'),
    meta: {
      resource: entityPatient,
      action: 'read',
      title: 'ReportForm037'
    }
  },
  {
    path: '/reports/outpatient-surgeries',
    name: 'outpatient-surgeries',
    component: () => import('@/views/reports/OutpatientSurgeries'),
    meta: {
      resource: entityPatientOutpatientSurgery,
      action: 'read',
      title: 'Outpatient surgeries'
    }
  },
  {
    path: '/reports/journal-of-paid-services',
    name: 'journal-of-paid-services',
    component: () => import('@/views/reports/JournalOfPaidServices'),
    meta: {
      resource: entityPatient,
      action: 'read',
      title: 'Journal of paid services'
    }
  },
  {
    path: '/reports/certificates-work-performed',
    name: 'certificates-work-performed',
    component: () => import('@/views/reports/CertificatesWorkPerformed'),
    meta: {
      resource: entityPatient,
      action: 'read',
      title: 'Register of certificates of work performed'
    }
  },
  {
    path: '/reports/paid-medical-services-information',
    name: 'paid-medical-services-information',
    component: () => import('@/views/reports/PaidMedicalServicesInformation'),
    meta: {
      resource: entityPatient,
      action: 'read',
      title: 'Information about scope of paid medical services'
    }
  },
  {
    path: '/reports/waybill-materials',
    name: 'report-waybill-materials',
    component: () => import('@/views/reports/WaybillMaterials'),
    meta: {
      resource: entityMaterialLot,
      action: 'read',
      title: 'List of materials in bill of lading'
    }
  },
  {
    path: '/reports/recommended-visits',
    name: 'report-recommended-visits',
    component: () => import('@/views/reports/RecommendedVisits'),
    meta: {
      resource: entityPatientRecommendedVisit,
      action: 'read',
      title: 'Recommended visits'
    }
  },
  {
    path: '/reports/patients-visits',
    name: 'report-patients-visits',
    component: () => import('@/views/reports/patient-visit/PatientVisit.vue'),
    meta: {
      resource: entitySchedulerPatient,
      action: 'read',
      title: 'Patients visits',
    },
  },
  {
    path: '/reports/visits-diseases',
    name: 'report-visits-diseases',
    component: () => import('@/views/reports/VisitsAndDiseases'),
    meta: {
      resource: entityTreatmentDiary,
      action: 'read',
      title: 'Visits and diseases report',
    },
  },
  {
    path: '/reports/ultrasound-logbook',
    name: 'report-ultrasound-logbook',
    component: () => import('@/views/reports/UltrasoundLogbook'),
    meta: {
      resource: entityTreatmentDiary,
      action: 'read',
      title: 'Ultrasound logbook',
    },
  },
  {
    path: '/reports/potential-calculation',
    name: 'potential-calculation',
    component: () => import('@/views/reports/financial-efficiency/PotentialCalculation'),
    meta: {
      resource: entityPatientPayment,
      action: 'read',
      title: 'Potential calculation'
    }
  },
  {
    path: '/reports/financial-efficiency',
    name: 'financial-efficiency-report',
    component: () => import('@/views/reports/financial-efficiency/FinancialEfficiency.vue'),
    meta: {
      resource: entityPatientPayment,
      action: 'read',
      title: 'Financial efficiency'
    }
  },
  {
    path: '/reports/work-performed-dl',
    name: 'work-performed-dl',
    component: () => import('@/views/reports/WorkPerformedDL'),
    meta: {
      resource: entityPurchaseOrder,
      action: 'read',
      title: 'Work performed (DL)'
    }
  }
]
